// extracted by mini-css-extract-plugin
module.exports = {"border":"GridCell_border__2NJxD"};